import React, { useEffect, useState } from "react";
import bsodImage from "./Icons/BSOD.png";
import error_sound from "./Audio/error.mp3";

const Bsod = ({ onTrigger }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // 🔊 Play the error sound
    const audio = new Audio(error_sound);
    audio.play().catch((err) => console.log("Audio playback failed:", err));

    let timeout;
    const increaseProgress = () => {
      // Random increment speed
      const increment = Math.floor(Math.random() * 10) + 1; // +1–10%
      setProgress((prev) => {
        const next = prev + increment;
        if (next >= 100) {
          clearTimeout(timeout);
          setTimeout(() => window.location.reload(), 1500);
          return 100;
        }
        timeout = setTimeout(increaseProgress, Math.random() * 2000 + 1500); // random delay
        return next;
      });
    };
    increaseProgress();
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${bsodImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 99999,
        color: "white",
        fontFamily: "Arial, sans-serif",
        fontSize: "35px",
      }}
    >
      <p
        style={{
          position: "absolute",
          left: 157,
          top: 382,
        }}
      >{`${progress}% complete`}</p>
    </div>
  );
};

export default Bsod;
